<template>
  <div class="article-wrap">
    <div class="article-container">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>

        <router-link class="bread-item" :to="{ name: 'academy' }">
          签证知识
        </router-link>

        <div class="bread-arrow" v-if="article.catalog_id === 1 || article.catalog_id === 2">&gt;</div>
        <router-link
          class="bread-item"
          v-if="article.catalog_id === 1 || article.catalog_id === 2"
          :to="{ name: article.catalog_id === 1 ? 'caseAnalysis' : 'latestNews' }"
        >
          {{ $maps.articleCategory[article.catalog_id] }}
        </router-link>

        <div class="bread-arrow" v-if="article.title">&gt;</div>
        <a class="bread-item" v-if="article.title">{{ article.title }}</a>
      </div>

      <div class="article-page clearfix">
        <div class="article-side">
          <div class="weixin">
            <p>更多签证资讯<br />关注上上签同业签证平台</p>
            <img src="../../assets/imgs/ssq-mp.jpg" alt="" width="140" />
            <small>微信扫码关注</small>
          </div>
          <div class="side-section" v-if="latest_article">
            <div class="header">最近更新</div>
            <router-link
              class="side-item"
              v-for="item in latest_article"
              :key="item.id"
              :to="{ name: 'article', params: { id: item.id } }"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>

        <div v-if="noData" style="text-align: center; padding-top: 100px">
          文章可能已被删除，您可查看其它文章！<br /><br />
          <router-link :to="{ name: 'academy' }" replace
            >{{ second5 }}S后返回签证知识</router-link
          >
        </div>

        <div class="article-main" v-if="article.title">
          <div class="title">{{ article.title }}</div>
          <div class="desc clearfix">
            <div class="date">
              {{ article.update_time }}
              <div class="views">
                <img src="../../assets/imgs/eye.png" alt="" />
                {{
                  article.hit > 999
                    ? Number((article.hit / 1000).toFixed(1)) + "k"
                    : article.hit
                }}
              </div>
            </div>
            <div
              class="keywords"
              v-if="article.keyword && article.keyword.length"
            >
              <div class="keyword" v-for="tag in article.keyword" :key="tag">
                {{ tag }}
              </div>
            </div>
          </div>
          <div class="content">
            <div class="main-box" v-html="article.content"></div>
          </div>
          <div class="footer" v-show="article.content">
            <router-link
              class="jump"
              v-if="pre"
              :style="$backgroundImage(pre.cover)"
              :to="{ name: 'article', params: { id: pre.id } }"
            >
              <div class="mask"></div>
              <div class="txt">
                <div class="target">上一篇</div>
                <div class="jump-title">{{ pre.title }}</div>
              </div>
            </router-link>
            <div class="jump no-jump" v-if="article.content && !pre">
              <div>
                <img src="../../assets/imgs/article-null.png" />
                <div class="tip">已经到头了</div>
              </div>
            </div>

            <router-link
              class="jump next"
              v-if="next"
              :style="$backgroundImage(next.cover)"
              :to="{ name: 'article', params: { id: next.id } }"
            >
              <div class="mask"></div>
              <div class="txt">
                <div class="target">下一篇</div>
                <div class="jump-title">{{ next.title }}</div>
              </div>
            </router-link>
            <div class="jump next no-jump" v-if="article.content && !next">
              <div>
                <img src="../../assets/imgs/article-null.png" />
                <div class="tip">已经到尾了</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from "../../libs/http";

export default {
  data() {
    return {
      articleId: +this.$route.params.id,
      article: {},
      hot_article: null,
      latest_article: null,
      pre: null,
      next: null,
      noData: false,
      second5: 5,
    };
  },

  watch: {
    "$route.params.id": function (nv) {
      if (nv) {
        this.articleId = +nv;
        this.getData();
      }
    },
  },

  methods: {
    getData() {
      this.$set(this.article, "content", "");

      Http.post("/sys/article_query", { id: this.articleId })
        .then((data) => {
          Object.assign(
            this,
            {},
            {
              article: data.article || {},
              hot_article: data.hot_article || null,
              latest_article: data.latest_article || null,
              pre: data.pre || null,
              next: data.next || null,
            }
          );

          if (!data.article) {
            this.timer = setInterval(() => {
              this.second5 = this.second5 - 1;

              if (!this.second5) {
                this.$router.replace({ name: "academy" });
              }
            }, 1000);

            return (this.noData = true);
          }
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
  },

  created() {
    this.getData();
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

.article-wrap {
  .article-container {
    width: 1120px;
    margin: 0 auto;
    display: block;
    height: 100%;
    position: relative;
  }
  .article-page {
    background-color: white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    padding: 40px;
    margin-bottom: 50px;
    border-radius: 1px;
  }

  .article-main {
    width: 720px;
    float: left;

    .title {
      font-size: 28px;
      font-weight: 500;
      color: #333;
    }

    .desc {
      margin-top: 20px;
    }

    .date {
      float: right;
      color: #aaa;
      font-size: 12px;
      line-height: 24px;
    }

    .views {
      display: inline-block;
      margin-left: 18px;

      img {
        position: relative;
        top: 1px;
      }
    }

    .keywords {
      max-width: 460px;
    }

    .keyword {
      height: 24px;
      line-height: 24px;
      padding: 0 4px;
      float: left;
      border: 1px solid @border;
      border-radius: 3px;
      font-size: 14px;
      color: #777;

      & + .keyword {
        margin-left: 10px;
      }
    }

    .content {
      padding-top: 40px;
      margin-top: 20px;
      border-top: 1px solid @border;
      .main-box {
        margin: 0;
        font-family: -apple-system, Segoe UI, Lucida Grande, Helvetica, Arial,
          Microsoft YaHei, FreeSans, Arimo, Droid Sans, wenquanyi micro hei,
          Hiragino Sans GB, Hiragino Sans GB W3, sans-serif;
        font-size: 13px;
        font-weight: 400;
        overflow: auto;
      }
    }

    iframe {
      width: 100%;
    }

    .footer {
      margin-top: 40px;
      border-top: 1px solid @border;
      padding-top: 30px;
    }

    .jump {
      float: left;
      width: 310px;
      height: 155px;
      border-radius: 6px;
      background: #f8f8f8 no-repeat center center;
      background-size: cover;
      position: relative;
      display: block;
      border: 1px solid @border;

      &:hover {
        border-color: lighten(@main, 20%);
      }

      &.next {
        float: right;
      }

      &.no-jump {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        &:hover {
          border-color: @border;
        }

        div {
          font-size: 14px;
          color: #aaa;
          margin-top: 5px;
        }
      }

      .mask {
        z-index: 1;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        bottom: 0;
        background-image: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.5)
        );
        border-radius: 6px;
      }

      .txt {
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 10px;
        color: white;
        z-index: 5;
      }

      .target {
        width: 80px;
        font-size: 14px;
        border-bottom: 1px solid white;
        padding-bottom: 8px;
      }

      .jump-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.3;
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .article-side {
    float: right;
    width: 280px;

    .weixin {
      border: 1px solid @border;
      background-color: #fbfbfb;
      text-align: center;
      padding: 18px 0 10px 0;

      p {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
      }

      img {
        display: block;
        margin: 8px auto 0 auto;
      }

      small {
        font-size: 14px;
        color: #aaa;
        display: inline-block;
        margin-top: 10px;
      }
    }

    .header {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-top: 40px;
      padding-bottom: 8px;
      border-bottom: 1px solid #333;
    }

    .side-item {
      font-size: 14px;
      color: #6f6f6f;
      line-height: 1.4;
      margin-top: 18px;
      display: block;

      &:first-of-type {
        margin-top: 16px;
      }

      &:hover {
        color: @main;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/article/article.vue